import { gql } from '@apollo/client';

const findManyCourseMetricDefinitionsQuery = gql`
  query FindManyCourseMetricDefinitions(
    $filter: FilterFindManyCourseMetricDefinitionInput
    $sort: SortFindManyCourseMetricDefinitionInput
  ) {
    findManyCourseMetricDefinitions(filter: $filter, sort: $sort) {
      _id
      key
      order
      isActive
      isRequired
      isVisibleToStudent
      isArchived
      scope
      valueType
      uiType
      inputSettings {
        allowDecimals
        allowNegative
      }
      translations {
        name {
          ua
        }
        description {
          ua
        }
        helpText {
          ua
        }
        placeholder {
          ua
        }
        unitName {
          ua
        }
      }
      validation {
        min
        max
      }
      chart {
        defaultType
      }
      options {
        key
        translations {
          ua
        }
      }
    }
  }
`;

export default findManyCourseMetricDefinitionsQuery;
